import { API_HOST } from '@/constants/config';

const toQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    searchParams.set(key, String(value));
  });
  const query = searchParams.toString();
  return query ? `?${query}` : '';
};

const fetchBlogSsr = async (path, params = {}) => {
  const url = `${API_HOST}${path}${toQueryString(params)}`;
  let response;
  try {
    response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Platform': 'web',
      },
    });
  } catch (networkErr) {
    throw new Error('Network error — unable to reach the blog service.');
  }

  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    throw new Error(
      response.ok
        ? 'Blog service returned an unexpected response.'
        : `Blog service returned ${response.status}.`,
    );
  }

  const data = await response.json();
  if (!response.ok || data?.error) {
    throw new Error(data?.message || 'Failed to fetch blog data');
  }

  return data;
};

/** Build-time + SEO routes for `/blog/category/[slug]`. */
export const blogApiSsr = {
  listCategorySlugsForStatic: async () => {
    const data = await fetchBlogSsr('/json/blog/categories');
    const rows = data.categories || [];
    return rows.filter((c) => c?.slug && !c.isLegacy).map((c) => c.slug);
  },

  getCategoryBySlug: async (slug) => {
    const s = String(slug || '').trim();
    if (!s) return null;
    try {
      const data = await fetchBlogSsr(`/json/blog/categories/${encodeURIComponent(s)}`);
      return data.category || null;
    } catch {
      return null;
    }
  },

  listPosts: async ({ page = 1, limit = 12, category } = {}) => {
    const data = await fetchBlogSsr('/json/blog/posts', { page, limit, category });
    return {
      posts: data.posts || [],
      pagination: data.pagination || {},
    };
  },
};
